// 브라우저 종류 (체크해야하는 순서로 나열되어 있음)
export enum BROWSER_TYPE {
  KAKAO = 'kakao',
  NAVER = 'naver',
  INSTA = 'instagram',
  WHALE = 'whale',
  SAMSUNG = 'samsungbrowser',
  EDGE = 'edge',
  QQ = 'qqbrowser',
  CHROME = 'chrome',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  MOZILLA = 'mozilla',
}

// 허용하지 않는 인앱 브라우저
export const notAllowInappList: BROWSER_TYPE[] = [
  BROWSER_TYPE.KAKAO,
  BROWSER_TYPE.NAVER,
  BROWSER_TYPE.INSTA,
  BROWSER_TYPE.FACEBOOK,
  BROWSER_TYPE.TWITTER,
];

// 허용하는 브라우저 리스트
export const allowBrowserList: BROWSER_TYPE[] = [
  BROWSER_TYPE.CHROME,
  BROWSER_TYPE.SAFARI,
  BROWSER_TYPE.FIREFOX,
  BROWSER_TYPE.SAMSUNG,
  BROWSER_TYPE.EDGE,
  BROWSER_TYPE.WHALE,
  BROWSER_TYPE.QQ,
  BROWSER_TYPE.MOZILLA,
];

/**
 * 인앱 허용 콘텐츠 리스트
 */
export const enableInAppContentList = [
  'ca6a603b-33f6-48d0-bd75-7b7c0c2211b4', //ca6a603b-33f6-48d0-bd75-7b7c0c2211b4
  'bNU0rbYdQK',
  'e087e4e3-a8b1-4d87-b5a3-cafe5fcb131e', //다양한 링크를 한곳에! 오찌데이 친구들 집에 초대할게요 (with 오찌데이)
  'O6Jkmz1HY2',
  '02723b7f-51b6-48ee-9af9-94c32f3e241e', //좋아해서 꽁꽁 숨겨놓은 숨은그림찾기 (with 하루랑 작가)
  'qKe4QDpbOX',
  '09c0d444-ebbd-4126-8ae9-60324e5610dd', //오늘 나의 운세는? 당신만을 위한 타로카드 (with 아르비 작가)
  '8eaE5psSON',
  'f72a3fa5-e1e7-47e4-8f3e-dc32e06ca02e', //미야오타운 입주 테스트 (with 미야오타운)
  'S45pvjeKms',
  'c08737df-9d51-4aef-ba54-01c50324e0ae', //연간캘린더_6월_미야오타운_영문
  'f3BJnLVcZ4',
  '3a1e987d-482e-4ca4-aa1a-31d8a5203973', //Hola! TAQUERIA: 내가 만든 맛있는 타코 (with 아바로떼스베)
  'JG5o7DvBZZ',
  '404bab3c-4878-446c-99cd-414b9d94e258', //아바로떼스베 - 타코만들기-KOR
  'dVj62eADrY',
  '10d759a3-2814-4bd4-b8ff-cd8ecae0e99e', //연간캘린더_7월_아바로떼스베_영문
  'Q1TZCGxpv9',
  'ec1b99a5-cdfc-4a49-8e09-199f19d33522', //시원한 여름을 부탁해! 둥아리와 친구들의 여름나기 (with 꼬질이)
  '952SqB600d',
  '59ae4a83-1d07-41f6-81c8-98fd30a000d9', //9월 월간 콘텐츠
  'DISUTpH7QE',
  '110efeef-538b-4aa2-9331-294a17166194', //10월 월간 콘텐츠
  '2ubiaex8uT',
  'f54ad1d8-426f-47d2-802d-e67e411fd577', //11월 콘텐츠
  'MXfhDz9lBG',
  '19d89159-06ca-4f34-8633-281710a0ba11', //12월 콘텐츠
];